import { FormConfig, FormValues, NextFunction } from '@topdanmark-onlinesolutions/claim-form-types';
import { getValueOrDefault } from '../components/values/Get';

export const getNextPage: NextFunction = async (curPageId: string, formConfig: FormConfig, formValues: FormValues) => {
    let nextPage: string | undefined = '';

    switch (curPageId) {
        case 'godt-at-vide':
            nextPage = 'om-modparten';
            break;
        case 'om-modparten':
            nextPage = 'dato';
            break;
        case 'dato':
            nextPage = 'om-kravet';
            break;
        case 'om-kravet':
            nextPage = 'beskriv-sagen';
            break;
        case 'beskriv-sagen':
            nextPage = 'beleob';
            break;
        case 'beleob':
            nextPage = 'er-sagen-indbragt-for-ankeinstans';
            break;
        case 'er-sagen-indbragt-for-ankeinstans':
            if (getValueOrDefault(formConfig, formValues, 'isAppealCase').value === 'ja') {
                nextPage = 'er-der-truffet-afgoerelse';
            } else {
                nextPage = 'er-sagen-indbragt-for-retten';
            }
            break;
        case 'er-der-truffet-afgoerelse':
            if (getValueOrDefault(formConfig, formValues, 'isAppealDecision').value === 'ja') {
                nextPage = 'om-medhold';
            } else {
                nextPage = 'er-sagen-indbragt-for-retten';
            }
            break;
        case 'om-medhold':
            nextPage = 'er-sagen-indbragt-for-retten';
            break;
        case 'er-sagen-indbragt-for-retten':
            nextPage = 'sag-mod-topdanmark';
            break;
        case 'sag-mod-topdanmark':
            nextPage = 'boern-under-18';
            break;
        case 'boern-under-18':
            nextPage = 'dokumentation';
            break;
        case 'dokumentation':
            nextPage = 'om-advokat';
            break;
        case 'om-advokat':
            if (getValueOrDefault(formConfig, formValues, 'haveSolicitor').value === 'Ja') {
                nextPage = 'hvilken-repraesentant';
            } else {
                nextPage = 'andet-selskab';
            }
            break;
        case 'hvilken-repraesentant':
            nextPage = 'andet-selskab';
            break;
        case 'andet-selskab':
            if (
                getValueOrDefault(formConfig, formValues, 'harduenforsikringietandetselskabsomdkkerdetsamme').value ===
                'Ja'
            ) {
                nextPage = 'hvilket-selskab';
            } else {
                nextPage = 'om-dig';
            }
            break;
        case 'hvilket-selskab':
            nextPage = 'om-dig';
            break;
        case 'om-dig':
            nextPage = 'resume';
            break;
        case 'resume':
            nextPage = undefined;
            break;
        default:
            throw new Error('Unknown page: ' + curPageId);
    }

    return nextPage;
};
